import React, { useState } from 'react';
import {postRequest} from './Services/HttpClient'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const PadaPaatham = () => {
    const [outputData, setOutputData] = useState([]);
    const [inputData, setInputData] = useState([]);
    const handleInputChange = async (event)=>{
      setInputData(event.target.value)
    }
    const  handleChange = async () => {
      var input = inputData;
      setOutputData("");
      var result = await postRequest('padapaatham', JSON.stringify({"input": input}));
      setOutputData(result.data);
  }
    
   return (
    <Container fluid="md">
      <Row>
        <Col xs={5} style={{ padding: '0px', backgroundColor: 'lightblue', height: '400px' }}>
        <textarea className="input-text-area" name="textarea" value={inputData} disabled={false} onChange={handleInputChange} />
        </Col>
        <Col xs={2}>
          <input id="display-button" type="submit" value="Show"  onClick={handleChange} />
        </Col>
        <Col >
          <Row style={{ padding: '0px', backgroundColor: 'lightblue', height: '400px' }}>
          <textarea className="output-text-area" value={outputData} />
          </Row>
        </Col>
      </Row>
  </Container>
  );
  };
  
  export default PadaPaatham;